export const BUILD_VERSION = '1.2.1-build.20261021.2049.00' as const
